import { Component, HostListener, OnInit } from '@angular/core';
import { AgCustomHeaderComponent } from 'src/app/shared/components/ag-grid/ag-custom-header/ag-custom-header.component';
import { AgGridI, AgGridPaginationConfig } from 'src/app/shared/components/ag-grid/ag-grid.model';
import { AgGridImportBOMPreview, AgGridImportCodecrosswalkPreview, AgGridImportCompaniesPreview, AgGridImportVendorPreview, ColumnName } from '../preview-tab/preview-tab.model'
import { Router } from '@angular/router';
import { CommonService } from 'src/app/shared/services/common.service';
import { ImportDocumentsService } from '../../import-documents.service';
import { Button, CurrentTab, RoutePath } from 'src/app/shared/model/enum';
import { ColDef } from 'ag-grid-community';
import { TabsService } from 'src/app/shared/components/tabs/tabs.service';
import { CodeCrosswalkService } from 'src/app/components/admin/code-crosswalk/code-crosswalk.service';
import { ProgressHelperService } from '../step-progressbar/progress-helper.service';


@Component({
  selector: 'app-preview-tab',
  templateUrl: './preview-tab.component.html',
  styleUrls: ['./preview-tab.component.scss']
})
export class PreviewTabComponent implements OnInit {
  enumButtonName = Button;
  enumColumnName = ColumnName;
  agGridPaginationConfig = new AgGridPaginationConfig();
  dataModel: AgGridI;
  private gridApi;
  private gridColumnApi;
  public components: {
    [p: string]: any;
  } = {
      agColumnHeader: AgCustomHeaderComponent,
    };
  rowData :any[] = [];
  flexHeight;
  public defaultColDef: ColDef = {
    resizable: true,
  };
  overlayNoRowsTemplate = '<div class="ag-overlay-no-rows-center">No Records Available</div>';
  currentTab:string;
  routeUrl:string;
  routePath = RoutePath;
  tabName = CurrentTab;
  isLoading: boolean = false;
 actWidth : number = 0;
  constructor(
    private router: Router,
    public commonService: CommonService,
    public importDocumentsService: ImportDocumentsService,
    public tabsService: TabsService,
    public codeCrosswalkService     :CodeCrosswalkService,
    public helperService : ProgressHelperService
  ) { 
    this.routeUrl = this.router.url;

  }
  @HostListener('window:resize', ['$event'])

  ngOnInit(): void {
    this.commonService.headerHeight.subscribe(res => {
      this.flexHeight = "calc(100vh - 290px - " + res + "px" + ")"
      if (this.routeUrl === this.routePath.CODECROSSWALK_ROUTEPATH) {
        this.flexHeight = "calc(100vh - 416px - " + res + "px)";
      }
    })
       this.helperService.actWidth.subscribe((res:any) => {
        this.actWidth = res
      })
    this.tabsService.currentTab.subscribe(res => {
      if (res !== undefined) {
        this.currentTab = res;
      } 
    })
    if(this.currentTab == this.tabName.CODECROSSWALK_TAB){
      this.dataModel = AgGridImportCodecrosswalkPreview;
    }else{
      if(this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH){
        this.dataModel =  AgGridImportVendorPreview
      }
      else if(this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH){
        this.dataModel = AgGridImportBOMPreview;
      }else{
      this.dataModel = AgGridImportCompaniesPreview;
    }
    }
    
    this.importDocumentsService.dataPassAccordingToTrackingBar.subscribe((res:any) => {
      if (res?.response?.moduleData !== undefined) {
        this.isLoading = true;
        this.rowData = this.currentTab == this.tabName.CODECROSSWALK_TAB?(res?.response?.moduleData?.codeCrosswalkData): this.currentTab == this.tabName.IMPORT_BOM_TAB?(res?.response?.moduleData?.data):(res?.response?.moduleData?.companyData);
        this.rowData = this.rowData.map((item:any) => {
          return {
            ...item,
            company : item?.companyName,
          }
        });
        this.gridApi?.setRowData(this.rowData);
        if(this.rowData?.length >= 0)
        this.isLoading = false;
      }
    });
  } 

  closeTab(){
    if(this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH){
      this.importDocumentsService.closeVendorTab();
      this.router.navigate([this.routePath.VENDORLIST_ROUTEPATH]);
      this.tabsService.currentTab.next(this.tabName.VENDORLIST_TAB)
    }else if(this.routeUrl == this.routePath.IMPORTBOM_ROUTEPATH){
      this.importDocumentsService.closeBOMTab();
      this.router.navigate([this.routePath.REQUIREMENT_ROUTEPATH]);
      this.tabsService.currentTab.next(this.tabName.REQUIREMENTS_TAB)
    }else{
      this.importDocumentsService.closeTab();
      this.router.navigate([this.routePath.COMPANY_ROUTEPATH]);
      this.tabsService.currentTab.next(this.tabName.COMPANY_TAB)
    }
  }
  close(){ 
    this.codeCrosswalkService.valuePopup.next(true)
   }
  
  backToImport() {
    const data = this.importDocumentsService.dataPassAccordingToTrackingBar.getValue();
    if (data) {
      const importData = data?.importCompanyModel ?? data;
      const importModel = data?.importModel ?? data;
      if (!data?.templateData?.isTemplateCreate && importData?.mappingTemplateId && importModel?.mappingTemplateId) {
        importData.mappingTemplateId = '';
      }
    }
    this.importDocumentsService.previuosTab.next(true);
  }
  handleClick() {
    if(this.rowData?.length >= 0){
      this.importDocumentsService.dataPassAccordingToTrackingBar.next(true);
     } else{
      this.importDocumentsService.errorValidation.next(true);
     }  
    }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
}
